$(document).ready(function(){
  count = 0;
  wordsArray = ["INSPIRED BY ITALY", "FOR 40 YEARS"];
  setInterval(function () {
    count++;
    $("#headingWord").fadeOut(400, function () {
      $(this).text(wordsArray[count % wordsArray.length]).fadeIn(400);
    });
  }, 5000);
  $(window).scroll(function(){
    var targetOffset = $(".logo-end").offset().top;
    var theta = document.documentElement.scrollTop / 433 % Math.PI;
      //$(".logo-end").css("transform","rotate("+ theta +"rad)");
  });
  //gallery brand slider
      $('#brandgslider').slick({
        dots: false,
        infinite: true,
        speed: 500,
        centerMode: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        centerPadding: '50px',
        autoplaySpeed: 2000,
        arrows: false,
        responsive: [{
          breakpoint: 769,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
           breakpoint: 400,
           settings: {
              arrows: false,
              slidesToShow: 3,
              slidesToScroll: 1
           }
        }]
    });
  //gallery brand slider
      $('#brandgcenterslider').slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        centerMode: true,
        centerPadding: '0px',
        autoplaySpeed: 2000,
        arrows: true,
        responsive: [
        {
           breakpoint: 990,
           settings: {
              slidesToShow: 1,
              slidesToScroll: 1
           }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
           breakpoint: 480,
           settings: {
              slidesToShow: 1,
              slidesToScroll: 1
           }
        }]
    });
  //colorcollectionslidermain slider
      $('#colorcollectionslidermain').slick({
        dots: false,
        infinite: true,
        speed: 500,
        centerMode: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        centerPadding: '0px',
        autoplaySpeed: 2000,
        arrows: false,
        dots:false,
        asNavFor:'.btncolorList',
        responsive: [{
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
           breakpoint: 480,
           settings: {
              slidesToShow: 1,
              slidesToScroll: 1
           }
        }]
    });
    $('.btncolorList').slick({
      slidesToShow: 5,
      asNavFor: '#colorcollectionslidermain',
      dots: false,
      arrows:true,
      centerPadding: '110px',
      centerMode: true,
      focusOnSelect: true,
      responsive: [{
          breakpoint: 769,
          settings: {
            slidesToShow: 4,
            centerPadding: '60px'
          }
        },
        {
           breakpoint: 480,
           settings: {
             centerPadding: '60px',
              slidesToShow: 3
           }
        }]
    });
  /*if ($(window).width() > 990) {
    if($('.parallax--bg01')){
      if($('.parallax--bg01').length > 0){
        $('.parallax--bg01').css('background-position','center 0px');
        $('.parallax--bg-lace0').css('background-position','center -300px');
      }
    }
  }
  if ($(window).width() <= 990) {
    if($('.parallax--bg01')){
      if($('.parallax--bg01').length > 0){
        $('.parallax--bg01').css('background-position','center 0px');
        $('.parallax--bg-lace0').css('background-position','center 0px');
      }
    }
  }*/
});

/* Parallax Work */
$(window).on('scroll resize',createLine);
function createLine(){
 var $i = $('#vline');
  var $window = $(window);
  var offset = 0;
  var minHeight = 10;
  var scrollPercentage = 100 * $window.scrollTop() / ($('html').height() - $window.height());
  var maxHeight = $(window).height() - (offset * 2) - minHeight;
  var newHeight = ((maxHeight / 100) * scrollPercentage) + minHeight;
  $i.css('height', newHeight);

   if ($(window).width() > 990) {
       if($(".mainHeroBanner")){
          if($('.mainHeroBanner').length > 0){
            var triggerAtY = $('.mainHeroBanner').offset().top - $(window).outerHeight();
            if (triggerAtY > $(window).scrollTop()) {
              return;
            }
          }
        // slideEffectImages();
       }
       if($('.parallaxPBG1')){
        if($('.parallaxPBG1').length > 0){
          var triggerAtY = $('.parallaxPBG1').offset().top - $(window).outerHeight();
          if (triggerAtY > $(window).scrollTop()) {
          return;
          }
          //parallax1();
          //parallaxLace1();
        }
      }
     if($('.parallax--bg01')){
      if($('.parallax--bg01').length > 0){
        var triggerAtY = $('.parallax--bg01').offset().top - $(window).outerHeight();
        if (triggerAtY > $(window).scrollTop()) {
          return;
        }
        //parallax3();
        //parallaxLace3();
      }
       
    }
     //slideTwoColumnImageEffect();
   }
  if ($(window).width() <= 990) {
    if($('.parallaxPBG1')){
        if($('.parallaxPBG1').length > 0){
          var triggerAtY = $('.parallaxPBG1').offset().top - $(window).outerHeight();
          if (triggerAtY > $(window).scrollTop()) {
          return;
          }
          //parallaxMobile1();
          //parallaxMobileLace1();
        }
      }
    if($('.parallax--bg01')){
      if($('.parallax--bg01').length > 0){
        var triggerAtY = $('.parallax--bg01').offset().top - $(window).outerHeight();
        if (triggerAtY > $(window).scrollTop()) {
          return;
        }
        //parallaxMobile3();
        //parallaxMobileLace3();
      }
    }
  }
  
}

function slideTwoColumnImageEffect(){
var $window = $(window);
  var offset = $('#animate_logo2').offset().top;
  var minHeight = 10;
  var scrolled_val = $(window).scrollTop();
  var triggerAtR = $('#firstRow').offset().top;
  var triggerAtR1 = $('#secondRow').offset().top;
  var laceheight = $('#secondRow').height();
  var heightquarter = laceheight;
  var initLY2 = triggerAtR;
  var initLB2 = laceheight + triggerAtR1;
  if (scrolled_val < initLY2 || scrolled_val > initLB2) {
    $('#secondRow').css("margin-top","0px");
    return;
  }
   console.log(scrolled_val+"==="+initLY2+"==="+initLB2);
 
  var scrollPercentage =  (scrolled_val - offset).toFixed(2);
  if(scrollPercentage > 300 && scrollPercentage <= 700){
    var scrolledPercentage1 = scrollPercentage;
    $('#secondRow').css("margin-top",(scrolledPercentage1)+"px");
 }else{
    $('#secondRow').css("margin-top","0px");
 }
}

function slideEffectImages(){
  var scrolled = $(window).scrollTop();
  var initY = $('.mainHeroBanner').offset().top;
  var oheight = $('.mainHeroBanner').height();
  var endY  = initY + $('.mainHeroBanner').oheight;
  var pbgLoc = scrolled - initY;
  var triggerAtY = $('.mainHeroBanner').offset().top - $(window).outerHeight();
  var iH = initY + oheight;
  var oH = scrolled + oheight;
  var bottom = $(window).height() - oheight;
  var initY2 = initY + oheight;
  
  if (scrolled < initY || scrolled > initY2) {
    $('.two-side-images .left-t-side').removeClass("objLeftMove");
    $('.two-side-images .right-t-side').removeClass("objRightMove");
    return;
  }
  $('.two-side-images .left-t-side').addClass("objLeftMove");
  $('.two-side-images .right-t-side').addClass("objRightMove");
}

function parallax1(){
  var scrolled = $(window).scrollTop();
  var initY = $('.parallaxPBG1').offset().top;
  var oheight = $('.parallaxPBG1').height();
  var endY  = initY + $('.parallax--bg1').oheight;
  var pbgLoc = scrolled - initY;
  var triggerAtY = $('.parallax--bg1').offset().top - $(window).outerHeight();
  var iH = initY + oheight;
  var oH = scrolled + oheight;
  var bottom = $(window).height() - oheight;
  var initY2 = initY + oheight;
  
  if (scrolled < initY || scrolled > initY2) {
    return;
  }
  var diff = scrolled - initY;
  var ratio = Math.round((diff / oheight) * 100);
  $('.parallax--bg1').css('background-position','center ' + ratio + 'px');

}

function parallaxLace1(){
  var scrolled = $(window).scrollTop();
  var height = $('.parallaxPBG1').height();
  
  var laceheight = $('.parallax--bg-lace1').height();
  var prevDivId = $('.parallaxPBG1').prev(".shopify-section").attr("id");
  var prevHeight = ($('.parallaxPBG1').height()) / 2;
  var initY = ($('.parallaxPBG1').offset().top) + prevHeight;
  
  
  $('.parallax--bg-lace1').css('height','800px');
  var initLY = $('.parallaxPBG1').offset().top;
  var initLY2 = initLY;
  var endLY  = initY + $('.parallax--bg-lace1').height();
  var iH = initLY + laceheight;
  var oH = scrolled + laceheight;
  var bottom = $(window).height() - height;
  var initY2 = initLY + height;
  if (scrolled < initLY2 || scrolled > initY2) {
    return;
  }
  var diff = scrolled - initLY2;
  var ratio = Math.round(diff);
  var ratio2 = ratio * 2;
  if(ratio2 < (height - 200) && ratio2 < 380){
    $('.parallax--bg-lace1').css('margin-top',(ratio * 2)+ 'px');
  }
}

function parallaxMobile1(){
  var scrolled = $(window).scrollTop();
  var initY = $('.parallaxPBG1').offset().top;
  var oheight = $('.parallaxPBG1').height();
  var endY  = initY + $('.parallax--bg1').oheight;
  var pbgLoc = scrolled - initY;
  var triggerAtY = $('.parallax--bg1').offset().top - $(window).outerHeight();
  var iH = initY + oheight;
  var oH = scrolled + oheight;
  var bottom = $(window).height() - oheight;
  var initY2 = initY + oheight;
  
  if (scrolled < initY || scrolled > initY2) {
    return;
  }
  var diff = scrolled - initY;
  var ratio = Math.round((diff / oheight) * 100);
  $('.parallax--bg1').css('background-position','center ' + ratio + 'px');

}

function parallaxMobileLace1(){
  var scrolled = $(window).scrollTop();
  var height = $('.parallaxPBG1').height();
  
  var laceheight = $('.parallax--bg-lace1').height();
  var prevDivId = $('.parallaxPBG1').prev(".shopify-section").attr("id");
  var prevHeight = ($('.parallaxPBG1').height()) / 2;
  var initY = ($('.parallaxPBG1').offset().top) + prevHeight;
  
  
 $('.parallax--bg-lace1').css('height',height+'px');
  var initLY = $('.parallaxPBG1').offset().top;
  var initLY2 = initLY;
  var endLY  = initY + $('.parallax--bg-lace1').height();
  var iH = initLY + laceheight;
  var oH = scrolled + laceheight;
  var bottom = $(window).height() - height;
  var initY2 = initLY + height;
  if (scrolled < initLY2 || scrolled > initY2) {
    return;
  }
  var diff = scrolled - initLY2;
  var ratio = Math.round(diff);
  var ratio2 = ratio * 2;
  if(ratio2 < (height - 200) && ratio2 < 380){
    $('.parallax--bg-lace1').css('margin-top',(ratio * 2)+ 'px');
  }
}

function parallax3(){
  var scrolled = $(window).scrollTop();
  var initY = $('.parallax--bg01').offset().top;
  var oheight = $('.parallax--bg01').height();
  var endY  = initY + $('.parallax--bg01').oheight;
  var pbgLoc = scrolled - initY;
  var triggerAtY = $('.parallax--bg01').offset().top - $(window).outerHeight();
  var iH = initY + oheight;
  var oH = scrolled + oheight;
  var bottom = $(window).height() - oheight;
  var initY2 = initY + oheight;
  
  if (scrolled < initY || scrolled > initY2) {
    return;
  }
  var diff = scrolled - initY;
  var ratio = Math.round((diff / oheight) * 100);
  $('.parallax--bg01').css('background-position','center ' + ratio + 'px');
}

function parallaxLace3(){
  var scrolled = $(window).scrollTop();
  var height = $('.parallax--bg01').height();
  var height21 = $('.parallax--bg01').height() / 3;
  var laceheight = $('.parallax--bg-lace0').height();
  var prevDivId = $('.parallax--bg01').prev(".shopify-section").attr("id");
  var prevHeight = ($('.parallax--bg01').parent().height()) / 3;
  var initY = ($('.parallax--bg01').offset().top) + prevHeight;
  $('.parallax--bg-lace0').css('height',height + 'px');
  var initLY = $('.parallax--bg01').offset().top;
  var heighthalf = laceheight / 3;
  var initLY2 = initLY - heighthalf;
  var endLY  = initY + $('.parallax--bg-lace0').height();
  var iH = initLY + laceheight;
  var oH = scrolled + laceheight;
  var bottom = $(window).height() - height;
  var initY2 = initLY + height;
  if (scrolled < initLY2 || scrolled > initY2) {
    return;
  }
  var diff = (scrolled - initLY) - 100;
  var matAbs = Math.abs(600 + diff);
  if(diff <= height21 && matAbs <= 520){
   $('.parallax--bg-lace0').css('background-position','center ' + (Math.abs(600 + diff) * -1)+ 'px');
  }
}

function parallaxMobile3(){
  var scrolled = $(window).scrollTop();
  var initY = $('.parallax--bg01').offset().top;
  var oheight = $('.parallax--bg01').height();
  var endY  = initY + $('.parallax--bg01').oheight;
  var pbgLoc = scrolled - initY;
  var triggerAtY = $('.parallax--bg01').offset().top - $(window).outerHeight();
  var iH = initY + oheight;
  var oH = scrolled + oheight;
  var bottom = $(window).height() - oheight;
  var initY2 = initY + oheight;
  
  if (scrolled < initY || scrolled > initY2) {
    return;
  }
  var diff = scrolled - initY;
  var ratio = Math.round((diff / oheight) * 100);
  $('.parallax--bg01').css('background-position','center ' + ratio + 'px');
}

function parallaxMobileLace3(){
  var scrolled = $(window).scrollTop();
  var height = $('.parallax--bg01').height();
  var height21 = $('.parallax--bg01').height() / 4;
  var laceheight = $('.parallax--bg-lace0').height();
  var prevDivId = $('.parallax--bg01').prev(".shopify-section").attr("id");
  var prevHeight = ($('.parallax--bg01').parent().height()) / 4;
  var initY = ($('.parallax--bg01').offset().top) + prevHeight;
  $('.parallax--bg-lace0').css('height',height + 'px');
  var initLY = $('.parallax--bg01').offset().top;
  var heighthalf = laceheight / 4;
  var initLY2 = initLY - heighthalf;
  var endLY  = initY + $('.parallax--bg-lace0').height();
  var iH = initLY + laceheight;
  var oH = scrolled + laceheight;
  var bottom = $(window).height() - height;
  var initY2 = initLY + height;
  if (scrolled < initLY2 || scrolled > initY2) {
    return;
  }
  var diff = scrolled - initLY;
  if(diff <= height21){
   $('.parallax--bg-lace0').css('background-position','center ' + (Math.abs(5 * diff) * -1)+ 'px');
  }
}

